module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a36baafaa06f48024a0a67c5c5e79a8d.png";